import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  actions: {
    async fetchRewards(_, params) {
      const res = (await axiosIns.get('/rewards', {
        params,
      })).data.data.data
      return res
    },
    getReward(_, rewardId) {
      return axiosIns.get(`rewards/${rewardId}`)
    },
    deleteReward(_, rewardId) {
      return axiosIns.delete(`rewards/${rewardId}`)
    },
    createReward(_, createRewardPayload) {
      return axiosIns.post('/rewards', createRewardPayload)
    },
    patchReward(_, { data, id }) {
      return axiosIns.patch(`/rewards/${id}`, data)
    },
  },
}
